
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import infoGetActions from '../../sagas/info';
import { getToken } from '../../reducers/auth';
import { getProjectKatuzeItems } from '../../reducers/project';

import IsknOpsubList from '../common/iskn/IsknOpsubList';

const IsknObjectListOpsub = ({data, isknDate, loading}) => {

    const dispatch = useDispatch();
    const infoActions = infoGetActions(dispatch);
    const token = useSelector(state => getToken(state.auth));
    const projectKatuzeItems = useSelector(state => getProjectKatuzeItems(state.project));

    const handleTelClick = (opsubId) => {
        infoActions.getObjectOpsub(
            token,
            projectKatuzeItems.map(item => item.kod),
            isknDate,
            opsubId
        );
    }

    return (
        <IsknOpsubList
            data={data}
            isknDate={isknDate}
            loading={loading}
            onClick={handleTelClick}
        />
    );
}

export default IsknObjectListOpsub;
